module.exports = __webpack_public_path__ + "844749a91ba91d918baddfe1d2485460.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/common/zhifubao.jpg
// module id = 658
// module chunks = 30